var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpectrum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 736,
    height: 140,
    viewBox: "0 0 736 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M598.173 184.829H117.782C114.05 184.829 112.895 179.776 116.257 178.155L516.763 -14.9497C517.265 -15.192 517.818 -15.3111 518.376 -15.2971L1295.77 4.20165C1297.38 4.24213 1298.76 5.37787 1299.11 6.95427L1337.47 180.56C1337.96 182.752 1336.29 184.829 1334.04 184.829H598.173Z",
    stroke: "#00FF94",
    strokeWidth: 1.89874
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M538.48 186H58.0894C54.3566 186 53.202 180.947 56.5643 179.326L457.07 -13.7793C457.572 -14.0216 458.125 -14.1407 458.683 -14.1267L1236.08 5.37206C1237.69 5.41254 1239.07 6.54828 1239.42 8.12468L1277.78 181.731C1278.26 183.923 1276.59 186 1274.35 186H538.48Z",
    stroke: "#00FF94",
    strokeWidth: 1.89874
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M496.343 180.148H15.9529C12.2201 180.148 11.0656 175.095 14.4279 173.473L414.933 -19.6314C415.436 -19.8736 415.989 -19.9927 416.546 -19.9787L1193.94 -0.47999C1195.55 -0.439508 1196.93 0.69623 1197.28 2.27263L1235.64 175.879C1236.13 178.071 1234.46 180.148 1232.21 180.148H496.343Z",
    stroke: "#00FF94",
    strokeWidth: 1.89874
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M616.135 148.545H244.253C240.517 148.545 239.366 143.485 242.734 141.869L552.368 -6.75919C552.869 -6.99963 553.42 -7.11777 553.976 -7.1039L1160.53 8.04228C1162.15 8.08255 1163.52 9.21668 1163.87 10.7917L1193.5 144.273C1193.99 146.466 1192.32 148.545 1190.07 148.545H616.135Z",
    fill: "#203376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpectrum);
export default __webpack_public_path__ + "static/media/spectrum.8508f86514123d399e3e323bda2e245d.svg";
export { ForwardRef as ReactComponent };